var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-container",
    { attrs: { id: "DocumentList" } },
    [
      _c(
        "v-card",
        [
          _c(
            "v-card-title",
            [
              _vm._v(" " + _vm._s(_vm.title) + " "),
              _c("v-spacer"),
              _c(
                "v-btn",
                { attrs: { color: "primary" }, on: { click: _vm.uploadFile } },
                [_vm._v(" " + _vm._s(_vm.$t("add-file")) + " ")]
              )
            ],
            1
          ),
          _c(
            "v-card-text",
            [
              _c(
                "div",
                { staticClass: "searchBox" },
                [
                  _c("v-text-field", {
                    attrs: {
                      "append-icon": "mdi-magnify",
                      label: _vm.$t("global.search"),
                      "aria-label":
                        _vm.$t("global.text-field") +
                        " " +
                        _vm.$t("global.search") +
                        " " +
                        _vm.$t("documents.documents"),
                      "single-line": "",
                      "hide-details": ""
                    },
                    model: {
                      value: _vm.search,
                      callback: function($$v) {
                        _vm.search = $$v
                      },
                      expression: "search"
                    }
                  })
                ],
                1
              ),
              _c("v-data-table", {
                attrs: {
                  filterable: "",
                  headers: _vm.computedHeaders.map(function(x) {
                    return Object.assign({}, x, { text: _vm.$t(x.text) })
                  }),
                  items: _vm.items,
                  "item-key": "id",
                  loading: _vm.loading,
                  search: _vm.search,
                  "items-per-page": _vm.rowsPerPage
                },
                scopedSlots: _vm._u([
                  {
                    key: "item.name",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "a",
                          { attrs: { target: "_blank", href: item.url } },
                          [_vm._v(" " + _vm._s(item.name) + " ")]
                        )
                      ]
                    }
                  },
                  {
                    key: "item.type",
                    fn: function(ref) {
                      var item = ref.item
                      return [_vm._v(" " + _vm._s(item.type) + " ")]
                    }
                  },
                  {
                    key: "item.created",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _vm._v(
                          " " + _vm._s(_vm.displayTime(item.created)) + " "
                        )
                      ]
                    }
                  },
                  {
                    key: "item.actions",
                    fn: function(ref) {
                      var item = ref.item
                      return [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "activator",
                                  fn: function(ref) {
                                    var on = ref.on
                                    return [
                                      item.id !==
                                      _vm.$store.getters.currentUserProfile.user
                                        .id
                                        ? _c(
                                            "v-icon",
                                            _vm._g(
                                              {
                                                staticClass: "mr-2",
                                                attrs: {
                                                  "aria-label":
                                                    _vm.$t("global.delete") +
                                                    " " +
                                                    _vm.$t(
                                                      "documents.documentParam",
                                                      [item.name]
                                                    )
                                                },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.deleteItem(item)
                                                  }
                                                }
                                              },
                                              on
                                            ),
                                            [_vm._v(" mdi-delete-outline ")]
                                          )
                                        : _vm._e()
                                    ]
                                  }
                                }
                              ],
                              null,
                              true
                            )
                          },
                          [_c("span", [_vm._v(_vm._s(_vm.$t("delete")))])]
                        )
                      ]
                    }
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "v-row",
        { attrs: { justify: "center" } },
        [
          _c(
            "v-dialog",
            {
              attrs: { "max-width": "500px" },
              model: {
                value: _vm.showDeleteDialog,
                callback: function($$v) {
                  _vm.showDeleteDialog = $$v
                },
                expression: "showDeleteDialog"
              }
            },
            [
              _c(
                "v-card",
                [
                  _c("v-card-text", [
                    _c("h3", { staticClass: "text-center text-white pt-10" }, [
                      _vm._v(
                        " " +
                          _vm._s(
                            _vm.$t("users.confirm-delete", [
                              _vm.editedItem.name
                            ])
                          ) +
                          " "
                      )
                    ])
                  ]),
                  _c(
                    "v-card-actions",
                    [
                      _c("v-spacer"),
                      _c("v-btn", { on: { click: _vm.closeDeleteDialog } }, [
                        _vm._v(" " + _vm._s(_vm.$t("global.cancel")) + " ")
                      ]),
                      _c(
                        "v-btn",
                        {
                          attrs: { color: "red" },
                          on: { click: _vm.confirmDeleteItem }
                        },
                        [_vm._v(" " + _vm._s(_vm.$t("global.confirm")) + " ")]
                      ),
                      _c("v-spacer"),
                      _c(
                        "v-overlay",
                        { attrs: { value: _vm.busy } },
                        [
                          _c("v-progress-circular", {
                            attrs: { indeterminate: "", size: "64" }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-card-actions",
            [
              _c(
                "v-dialog",
                {
                  attrs: { persistent: "", "max-width": "600px" },
                  model: {
                    value: _vm.showUploadModal,
                    callback: function($$v) {
                      _vm.showUploadModal = $$v
                    },
                    expression: "showUploadModal"
                  }
                },
                [
                  _c("upload-document", {
                    ref: "uploadDocumentComponent",
                    attrs: {
                      "exceeded-max-file-uploaded": _vm.exceededMaxFileUploaded,
                      items: _vm.items
                    },
                    on: {
                      uploadedFileToSave: _vm.uploadedFile,
                      save: _vm.saveFile,
                      closeModal: _vm.closeModal
                    }
                  }),
                  _c(
                    "v-overlay",
                    { attrs: { value: _vm.uploadProgress } },
                    [
                      _c("v-progress-circular", {
                        attrs: { indeterminate: "", size: "64" }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }